<template>
<Form
	ref="form"
	class="m-0 p-0 g-0"
	@submit="onSubmit"
	@invalid-submit="console.log"
	:validation-schema="schema"
	:initial-values="formValues"
	v-slot="{ errors, meta, values, isSubmitting }"
>
	<fieldset :disabled="!isFormEnabled">
		<div style="display: none;">
			{{ formMeta = meta }}
			{{ isSubmittingForm = isSubmitting }}
		</div>

		<a :id="sections.calibration.anchor" class="anchor-shift" />
		<div ref="calibrationRef" class="row form-row m-0 p-0">
			<div class="col m-0 py-0">
				Версія: {{ serviceUnitVersion }}
			</div>
		</div>
	<div class="row form-row m-0 p-0">
		<div class="form-group col my-1 input-min-width">
			<label>Калібрування канала вимірювання напруги живлення 220В</label><br />
			<Field
				:name="`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.u220Adjust}`"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="{ 'is-invalid': errors[`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.u220Adjust}`] }"
			/>
			<div class="invalid-feedback">{{errors[`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.u220Adjust}`]}}</div>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Station.passportKeys.serviceUnit.u220Adjust)"
			>
				Поточне значення регістра: 
				{{ station.getMetric(Station.passportKeys.serviceUnit.u220Adjust)?.value?.toFixed(2) }}
			</div>
		</div>
	</div>
	<div class="row form-row m-0 p-0">
		<div class="form-group col my-1 input-min-width">
			<label>Калібрування канала 1</label>
			<Field
				:name="`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.channel1Adjust}`"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="{ 'is-invalid': errors[`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.channel1Adjust}`] }"
			/>
			<div class="invalid-feedback">{{errors[`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.channel1Adjust}`] }}</div>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Station.passportKeys.serviceUnit.channel1Adjust)"
			>
				Поточне значення регістра: 
				{{ station.getMetric(Station.passportKeys.serviceUnit.channel1Adjust)?.value?.toFixed(2) }}
			</div>
		</div>
	</div>
	<div class="row form-row m-0 p-0">
		<div class="form-group col my-1 input-min-width">
			<label>Калібрування канала 2</label>
			<Field
				:name="`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.channel2Adjust}`"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="{ 'is-invalid': errors[`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.channel2Adjust}`] }"
			/>
			<div class="invalid-feedback">{{errors[`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.channel2Adjust}`] }}</div>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Station.passportKeys.serviceUnit.channel2Adjust)"
			>
				Поточне значення регістра: 
				{{ station.getMetric(Station.passportKeys.serviceUnit.channel2Adjust)?.value?.toFixed(2) }}
			</div>
		</div>
	</div>
	<div class="row form-row m-0 p-0">
		<div class="form-group col my-1 input-min-width">
			<label>Калібрування канала шунта</label>
			<Field
				:name="`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.shuntAdjust}`"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="{ 'is-invalid': errors[`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.shuntAdjust}`] }"
			/>
			<div class="invalid-feedback">{{errors[`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.shuntAdjust}`] }}</div>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Station.passportKeys.serviceUnit.shuntAdjust)"
			>
				Поточне значення регістра: 
				{{ station.getMetric(Station.passportKeys.serviceUnit.shuntAdjust)?.value?.toFixed(2) }}
			</div>
		</div>
	</div>

	<div class="form-row row row-cols-1 m-0 p-0 mt-2">
		<!-- {{ console.log('relatedRpc', relatedRpc) }} -->
		<dl v-if="relatedRpc" class="mb-1 text-dark">
			<dt>Останній запит запису регістрів</dt>
			<dd class="mb-0 ms-3">
				Відправив: <span class="font-monospace">{{ relatedRpc.context?.writer?.name }}</span>
				<span v-if="relatedRpc.context?.writer?.organization?.name" class="font-monospace">&nbsp;({{ relatedRpc.context?.writer?.organization?.name }})</span>
			</dd>
			<dd class="mb-0 ms-3">
				Час: <span class="font-monospace">{{ dateTimeToString(relatedRpc[rpcTaskSchema.updateTime.key], false, false, true) }}</span>
			</dd>
			<dd class="mb-0 ms-3">
				Стан: <span
					class="font-monospace"
					:class="{
						'text-danger': rpcTaskSchema.state.isErorrState(relatedRpc?.state),
						'text-success': !rpcTaskSchema.state.isErorrState(relatedRpc?.state),
					}"
				>
					{{ taskStateDescription(relatedRpc?.state) }}
				</span>
			</dd>
		</dl>
	</div>

	<div class="row row-cols-1 m-0 p-0 my-3">
		<div class="col-12 my-0">
			<p v-if="feedbackPromt.length > 0" class="m-0" :class="feedbackPromtClass">
				{{ feedbackPromt }}
			</p>
			<p v-else-if="meta.dirty && meta.valid" class="text-success m-0">
				Натисніть "Зберегти і записати регістри" щоб примінити налаштування і записати зміни в регістри модулів.
			</p>
			<p v-else-if="meta.dirty && !meta.valid" class="text-danger m-0">
				Є поля що заповнені некоректно.
			</p>
			<p v-else class="m-0">&nbsp;</p>
		</div>
	</div>

	<!-- <pre>Errors: {{ errors }}</pre> -->
	<!-- <pre>Meta: {{ meta }}</pre> -->

	<div class="row form-row m-0 p-0 mt-1 mb-3">
		<div class="form-group col-auto me-0">
			<button
				ref="submitButtonRef"
				type="submit"
				class="btn btn-primary btn-sm"
				:disabled="!meta.valid || !meta.dirty || isSubmitting"
			>
				Зберегти
			</button>
		</div>
	</div>
	</fieldset>
</Form>
</template>




<script>
import { useStationsStore } from '@/stores/StationsStore.js'
import { useAccontStore } from '@/stores/AccountStore.js'
import { rpcTaskSchema, useRpcTasks } from '@/composables/rpcTasks.js'
// Validation
// https://jasonwatmore.com/post/2020/10/01/vue-3-veevalidate-form-validation-example
import { Form, Field } from 'vee-validate'
// https://github.com/jquense/yup/tree/a58f02d2f6164c46a9757a818eebac582f7a441c#boolean
import * as Yup from 'yup';

import { Station } from '@/models/station'
import {
	capitalizeFirstLetter,
	dateTimeToString,
	getObjectDiff,
} from '@/helpers.js'
import { ServiceUnit } from '@/models/serviceUnit';


export default {
	requiredPromt: 'Обов\'язкове поле',
	overMinLenPromt: 'Довжина меньше мінімальної',
	overMaxLenPromt: 'Довжина більше максимальної',
	overMinPromt: 'Значення меньше мінімального',
	overMaxPromt: 'Значення більше максимального',
	onlyIntegersPromt: 'Має бути цілим числом',
	onlyPositivePromt: 'Має бути натуральним числом',
	wrongInputPromt: 'Не відповідає вимогам',

	components: {
		Form,
        Field,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	emits: {
		rpc: (promt) => typeof promt === 'object',
		sections: (s) => typeof s === "object",
		saveFunction: (f) => typeof f === 'function',
		saveFunctionActive: (f) => typeof f === 'boolean',
	},

	setup() {
		const stationsStore = useStationsStore()
		const accountStore = useAccontStore()
		const { createRpc, readRpc } = useRpcTasks()

		return {
			stationsStore,
			accountStore,
			createRpc,
			readRpc,
			Station,
			capitalizeFirstLetter,
			dateTimeToString,
			rpcTaskSchema,
		}
	},

	data() {
		const schema = Yup.object().shape({
			service_unit:	Yup.object().shape({
				[Station.passportKeys.serviceUnit.u220Adjust]: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.positive(this.$options.onlyPositivePromt)
					.min(50, this.$options.overMinPromt)
					.max(400, this.$options.overMaxPromt),
				[Station.passportKeys.serviceUnit.channel1Adjust]: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.positive(this.$options.onlyPositivePromt)
					.min(1500, this.$options.overMinPromt)
					.max(2500, this.$options.overMaxPromt),
				[Station.passportKeys.serviceUnit.channel2Adjust]: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.positive(this.$options.onlyPositivePromt)
					.min(1500, this.$options.overMinPromt)
					.max(2500, this.$options.overMaxPromt),
				[Station.passportKeys.serviceUnit.shuntAdjust]: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.positive(this.$options.onlyPositivePromt)
					.min(7000, this.$options.overMinPromt)
					.max(8000, this.$options.overMaxPromt),
			})
		})

		return {
			// Form
			schema,
			formMeta: {},
			isSubmittingForm: false,

			relatedRpc: undefined,
			rpcUpdateInterval: null,

			observer: null,

			sections: {
				calibration: {
					anchor: 'service_unit_calibration',
					title: 'Калібрування',
					intersectionRatio: 0,
				},
			},

			// Feedback promt
			feedbackPromtClass: '',
			feedbackPromt: '',
		}
	},

	watch: {
		formMeta(newMeta) {
			if (newMeta) {
				this.$emit('saveFunctionActive', newMeta.valid && newMeta.dirty && !this.isSubmittingForm)
			}
		},
	},

	created() {
		this.readRelatedRpc()
	},

	mounted() {
		this.$emit('saveFunction', this.submitButtonClick)

		this.observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.target === this.$refs.calibrationRef) {
						this.sections.calibration.intersectionRatio = entry.intersectionRatio
					}
				})
			},
			{
				root: null,
				rootMargin: '0px',
				threshold: [0, 0.5, 1],
			}
		)

		this.observer.observe(this.$refs.calibrationRef)
		this.$emit('sections', this.sections)
	},

	methods: {
		submitButtonClick() {
			this.$refs.submitButtonRef.click()
		},

		fieldDynamicClasses(values, errors, valueKey) {
			const isInvalid = errors[`${Station.passportKeys.serviceUnit.self}.${valueKey}`]
			const isMatchRegister =
				(values[Station.passportKeys.serviceUnit.self]
					? values[Station.passportKeys.serviceUnit.self][valueKey]
					: undefined) == this.station.getMetric(valueKey)?.value?.toFixed(2)

			return {
				'is-invalid': isInvalid,
				'not-match-register': !isMatchRegister && !isInvalid,
			}
		},

		async readRelatedRpc() {
			if (this.relatedRpcId == undefined) {
				return
			}

			this.relatedRpc = await this.readRpc(this.relatedRpcId)
			this.$emit('rpc', this.relatedRpc)
		},

		taskStateDescription(state) {
			const stateObj = this.rpcTaskSchema.state.findState(state)
			return stateObj == undefined || stateObj == false
				? "невизначено"
				: stateObj.title
		},

		async onSubmit(values) {
			let settingsWriteResult = false
			let passportWriteResult = false
			let relatedRpcId = undefined

			// Keys that need to be write to registers
			const settingsKeys = new Set([
				'u220_adjust',
				'channel_1_adjust',
				'channel_2_adjust',
				'shunt_adjust',
			])

			// Found changed values in settings
			const diff = getObjectDiff(
				this.formValues[Station.passportKeys.serviceUnit.self],
				values[Station.passportKeys.serviceUnit.self]
			)
			let changedSettings = new Set()
			if (diff !== null) {
				const changedKeys = new Set(Object.keys(diff))
				changedSettings = settingsKeys.intersection(changedKeys)
			}
			
			// If there is any changes in settings		
			if (changedSettings.size > 0) {
				// Set changed settings to payload Object
				const payload = {}
				for (const setting of changedSettings) {
					payload[setting] = values[Station.passportKeys.serviceUnit.self][setting]
				}

				// Submit settings to server
				relatedRpcId = await this.submitSettings(payload)
				settingsWriteResult = relatedRpcId === false ? false : true
			} else {
				settingsWriteResult = true
			}

			if (settingsWriteResult) {
				// Submit passport to server
				this.submitPassport(values, relatedRpcId)
				passportWriteResult = true
			}

			return settingsWriteResult && passportWriteResult
		},

		submitPassport(values, relatedRpcId=undefined) {
			const payload = {
				[Station.passportKeys.serviceUnit.self]: { ...values[Station.passportKeys.serviceUnit.self] }
			}
			payload[Station.passportKeys.updateBy] = this.accountStore.userId

			// Save rpc id
			if (relatedRpcId) {
				payload[Station.passportKeys.serviceUnit.self][Station.passportKeys.serviceUnit.relatedRpc] = relatedRpcId
			}

			this.stationsStore.updatePasport(
				(result) => {
					if (result) {
						this.printHint('Паспорт успішно оновлено.')
						this.stationsStore.readPassport(undefined, this.stationId)
						this.rpcUpdateInterval = setInterval(async () => {
							this.readRelatedRpc()
						}, 1000)
					} else {
						this.printErr('Сервер відхилив запит.')
					}
				},
				this.stationId,
				payload,
			)
		},

		async submitSettings(values) {
			// console.log("Submit settings", values)
			if (this.relatedRpc?.complete === false) {
				this.printErr(
					`Станція вже обробляє інший запит (${rpcTaskSchema.job.findJob(this.relatedRpc.job).title}). `
					+'Будь ласка дочекайтесь його виконання.',
				)

				return false
			} else if (!this.station.isActive) {
				this.printErr('Станція не активна. Тільки активні станції виконують запити.')
				return false
			} else if (this.relatedRpc === undefined
				|| this.relatedRpc.complete === true
			) {
				return await this.writeRpc(values)
			} else {
				this.printErr('Сталася невідома помилка')
				return false
			}
		},

		async writeRpc(values) {
			const context = {}
			context.settings = values
			
			context.unit = Station.passportKeys.serviceUnit.self
			context.writer = {
				"name": this.accountStore.userName,
				"id": this.accountStore.userId,
				"organization": {
					"name": this.accountStore.organization["title"],
					"id": this.accountStore.organization["_id"],
				},
			}

			return await this.createRpc(
				this.accountStore.userId,
				rpcTaskSchema.job.allowed.setUnitRegisters.key,
				this.stationId,
				null,
				context,
			).then((result) => {
				if (result) {
					this.printHint('Запит надіслано. Спостерігайте за його станом.')
				} else {
					this.printErr('Сервер відхилив запит постановки завдання.')
				}

				return result
			})
		},

		printHint (msg) {
			this.feedbackPromtClass = "text-success"
			this.feedbackPromt = msg
		},

		printErr (msg) {
			this.feedbackPromtClass = "text-danger"
			this.feedbackPromt = msg
		},
	},

	computed: {
		station() { return this.stationsStore.station(this.stationId) },

		isFormEnabled() { return this.accountStore.permissions.includes('manage_stations') },

		relatedRpcId() {
			const serviceUnitPassport = this.station?.passport.get(Station.passportKeys.serviceUnit.self)
			return serviceUnitPassport ? serviceUnitPassport[Station.passportKeys.serviceUnit.relatedRpc] : undefined
		},

		serviceUnitVersion() {
			const serviceUnitPassport = this.station?.passport.get(Station.passportKeys.serviceUnit.self)
			return ServiceUnit.versionNames[serviceUnitPassport[Station.passportKeys.serviceUnit.unitVersion]]
		},

		formValues() {
			const serviceUnitPassport = { ...this.station?.passport.get(Station.passportKeys.serviceUnit.self) }

			return {
				[Station.passportKeys.serviceUnit.self]: {
					u220_adjust: serviceUnitPassport.u220_adjust,
					shunt_adjust: serviceUnitPassport.shunt_adjust,
					channel_1_adjust: serviceUnitPassport.channel_1_adjust,
					channel_2_adjust: serviceUnitPassport.channel_2_adjust,
				},
			}
		},
	},

	beforeUnmount() {
		if (this.rpcUpdateInterval != null) {
			clearInterval(this.rpcUpdateInterval)
			this.rpcUpdateInterval = null
		}

		if (this.observer) {
			this.observer.disconnect()
		}
	},
}
</script>




<style scoped>
/* Remove arrows from input Chrome, Safari, Edge, Opera */
input.no-arrow::-webkit-outer-spin-button,
input.no-arrow::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Remove arrows from input Firefox */
input[type=number].no-arrow {
	appearance: textfield;
	-moz-appearance: textfield;
}

.input-min-width {
	min-width: 33ch; 
	max-width: 70ch;
	width: 100%;
}

/* Style for input if it is not match register value */
.not-match-register {
	border-color: rgb(11, 94, 215);
	color: rgb(11, 94, 215);
}

.cur-value-promt {
	font-size: 0.875em;
}
</style>